import React from 'react'

import {BaseDialog, Role} from 'dialogs/BaseDialog';
import Header from 'common/Header';
import LogoutTimer from '../LogoutTimer';
import {getMessage as msg} from 'MessageBundle'
import theme from './Admin.scss';
import {TabPanel, TabView} from "common/TabView";
import ParameterTab from './ParameterTab';
import RelationshipTab from './RelationshipTab';
import TemplateTab from './TemplateTab';
import LayoutTab from './LayoutTab';
import LayoutFieldTab from './LayoutFieldTab';

const ADMIN_TABS = new Map([
    [0, 'parameterTab'],
    [1, 'relationshipTab'],
    [2, 'templateTab'],
    [3, 'layoutTab'],
    [4, 'layoutFieldTab'],
]);
export default class Admin extends BaseDialog {

    constructor(props) {
        super(props);

    }

    getAllowedRoles() {
        return [Role.ADMIN];
    }

    componentDidMount() {
        super.init();
    }

    handleTabClick = (e) => {
        const activeTab = this[ADMIN_TABS.get(this.tabView.state.activeIndex)];
        if (!activeTab.state.dataChanged || confirm(msg("admin.confirmResetChanges"))) {
            this[ADMIN_TABS.get(e.index)].reloadData();
        } else {
            e.preventTabChange = true;
        }
    };

    handleCloseWindowClick = () => {
        const activeTab = this[ADMIN_TABS.get(this.tabView.state.activeIndex)];
        if (!activeTab.state.dataChanged || confirm(msg("admin.confirmResetChanges"))) {
            this.closeWindow();
        }
    };

    handleFieldListOpen =() => {
        window.open('/fieldlist', '_blank', 'left=100,top=100,width=550,height=650,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes');
    };

    getDialog() {
        return (
            <div className={theme.admin}>
                <Header value={msg('vprekla.header')}>
                    <h2>{msg('admin.header')}</h2>
                    <ul>
                        <li>
                            <a href="#">{msg('navigationMenu.helpLnk')}</a>
                        </li>
                        <li>
                            <LogoutTimer timeout={this.state.logoutTimeout} onTimeOver={() => this.logout(this.state.tvppLogoutUrl)}/>
                        </li>
                    </ul>
                </Header>
                <section>
                    <h2>{msg('admin.title')}</h2>
                    <div className={theme.content}>
                        <TabView className={theme.tabWrap} onTabClick={this.handleTabClick} ref={(tabView) => this.tabView = tabView}>
                            <TabPanel header={msg('admin.parameterTab.header')}>
                                <ParameterTab ref={(tab) => this.parameterTab = tab}/>
                            </TabPanel>
                            <TabPanel header={msg('admin.relationshipTab.header')}>
                                <RelationshipTab ref={(tab) => this.relationshipTab = tab}/>
                            </TabPanel>
                            <TabPanel header={msg('admin.templateTab.header')} >
                                <TemplateTab onFieldListClick={this.handleFieldListOpen} ref={(tab) => this.templateTab = tab}/>
                            </TabPanel>
                            <TabPanel header={msg('admin.layoutTab.header')} >
                                <LayoutTab onFieldListClick={this.handleFieldListOpen} ref={(tab) => this.layoutTab = tab}/>
                            </TabPanel>
                            <TabPanel header={msg('admin.layoutFieldTab.header')} >
                                <LayoutFieldTab onFieldListClick={this.handleFieldListOpen} ref={(tab) => this.layoutFieldTab = tab}/>
                            </TabPanel>
                        </TabView>

                        <button onClick={this.handleCloseWindowClick} className={theme.btnCancel}>
                            {msg('admin.cancelButton')}
                        </button>
                    </div>
                </section>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Admin/index.js